module.exports = __webpack_public_path__ + "static/media/RealTimeCommunication_Elec_003.f4cfd454.png";